export const en = () => {
  return {
    loginHeadingMain: "Welcome back",
    loginHeadingSec: "Login to your CRMCaller account",
    loginButtonLabel: "Login",
    registerButtonLabel: "Register",
    alreadyHaveAccountLabel: "Already have an account?",
    alreadyHaveAccountCtaLabel: "Sign in",
  };
};
